<template>
  <v-layout justify-center>
    <div>
      <v-layout>
        <v-flex xm12 md4 offset-md4 class="text-sm-center">
          <span class="headline">Emails Sent</span><br />
        </v-flex>
      </v-layout>

      <v-flex xs12>
        <vue-good-table
          ref="my-table"
          styleClass="vgt-table striped bordered"
          :max-height=this.height
          :fixed-header="true"
          :isLoading=this.isTableLoading
          :columns="columns"
          :rows="rows"
          :select-options="{
            enabled: true,
            selectOnCheckboxOnly: true
          }"
          :search-options="{
            enabled: true
          }">
          <template slot="loadingContent">
            <div>
              <v-progress-circular
                :size="50"
                :width="7"
                color="blue"
                indeterminate
              ></v-progress-circular>
            </div>
          </template>
          <div slot="table-actions-bottom">
            <span class="body-2" style="padding-left: 20px;">Number of records: {{ totalCount }}</span>
          </div>
          <template slot="table-row" slot-scope="props">
            <span v-if="props.column.field == 'area'">
              <v-layout align-center justify-start row fill-height>
                <v-flex xs12>
                  {{ props.row.area }} sqft
                </v-flex>
              </v-layout>
            </span>
            <span v-else-if="props.column.field == 'actions'">
              <div class="text-xs-center">
                <v-avatar
                  v-if="isAdmin"
                  color="blue lighten-4"
                  class="mr-2 mt-2"
                  size="30"
                  style="cursor: pointer;"
                  @click="editItem(props)"
                >
                  <v-icon small>edit</v-icon>
                </v-avatar>
              </div>
            </span>
            <span v-else>
              {{props.formattedRow[props.column.field]}}
            </span>
          </template>
        </vue-good-table>
      </v-flex>

      <v-btn
        fab
        bottom
        right
        color="blue"
        dark
        fixed
        class="add-button-bottom"
        @click="dialog = !dialog"
      >
        <v-icon>add</v-icon>
      </v-btn>

      <v-dialog v-model="dialog" max-width="500px" persistent>
        <v-card >
          <v-toolbar card dark color="primary">
            <v-btn icon dark @click="close">
              <v-icon>close</v-icon>
            </v-btn>
            <v-toolbar-title>Add/Edit Booth</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <!-- <v-btn v-if="edit" dark flat @click="updateItem">Udate</v-btn> -->
              <v-btn dark flat @click="save">Save</v-btn>
            </v-toolbar-items>
          </v-toolbar>

          <v-card-text>
            <v-container grid-list-md>
              <v-layout class="pb-3" row wrap>
                <v-flex xs12>
                  <v-text-field
                    v-model="evalItem.boothNumber"
                    @keyup.enter="save"
                    label="Booth Number"
                  ></v-text-field>
                </v-flex>
                <v-flex v-if="evalItem.VendorCompanyId === 0 || evalItem.VendorCompanyId === null" xs12>
                  <v-select
                    v-model="evalItem.VendorCompanyId"
                    :items="vendors"
                    item-text="name"
                    item-value="value"
                    label="Vendor"
                  ></v-select>
                </v-flex>
                <v-flex xs12>
                  <v-select
                    v-model="evalItem.location"
                    :items="locations"
                    item-text="name"
                    item-value="value"
                    label="Location"
                  ></v-select>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    v-model="evalItem.size"
                    @keyup.enter="save"
                    label="Size"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    v-model="evalItem.area"
                    @keyup.enter="save"
                    label="Area (SqFt)"
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>

      <v-snackbar
        v-model="snackbar.show"
        :color="snackbar.color"
        :multi-line=true
        :timeout="6000"
      >
        {{ snackbar.message }}
        <v-btn
          dark
          flat
          @click="snackbar.show = false"
        >
          Close
        </v-btn>
      </v-snackbar>
      </div>
  </v-layout>
</template>

<script>
import Api from '@/services/Api'
import { VueGoodTable } from 'vue-good-table'
import 'vue-good-table/dist/vue-good-table.css'
import moment from 'moment'

export default {
  props: ['visible', 'currentYear'],

  components: {
    VueGoodTable
  },
  data () {
    return {
      myId: this.$store.state.user.id,
      page: 'booth',
      isAdmin: this.$store.state.isAdmin,
      dialog: false,
      loading: false,
      isTableLoading: false,
      isMounted: false,
      toggle_multiple: ['chair', 'assist', 'excel'],
      snackbar: {
        show: false,
        color: '',
        message: ''
      },
      editedIndex: -1,
      height: 0,
      columns: [
        {
          label: 'To',
          field: 'to',
          thClass: 'hidden-sm-and-down text-center',
          tdClass: 'hidden-sm-and-down',
          type: 'text'
        },
        {
          label: 'From',
          field: 'from',
          thClass: 'text-center',
          html: true
        },
        {
          label: 'Subject',
          field: 'subject',
          thClass: 'hidden-sm-and-down text-center',
          tdClass: 'hidden-sm-and-down',
          type: 'text'
        },
        {
          label: 'Date',
          field: 'date',
          thClass: 'hidden-sm-and-down text-center',
          tdClass: 'hidden-sm-and-down',
          html: true
        },
        {
          label: 'Action',
          field: 'actions',
          thClass: 'text-center',
          tdClass: 'text-center',
          sortable: false,
          hidden: false,
          html: true,
          width: '60px'
        }
      ],
      rows: [],
      newRows: [],
      evalItem: {},
      vendors: [],
      locations: [
        {value: 'Western Hall', name: 'Western Hall'},
        {value: 'South Hall 3', name: 'South Hall'},
        {value: 'Outside', name: 'Outside'},
        {value: 'South Lot 2', name: 'South Lot'}
      ]
    }
  },

  created () {
    this.isTableLoading = true

    this.loading = true

    window.addEventListener('resize', this.handleResize)
    this.handleResize()

    this.getEmails()

    this.loading = false
    // console.log(this.$refs)
  },

  mounted () {
    this.isMounted = true
  },

  destroyed () {
    window.removeEventListener('resize', this.handleResize)
  },

  computed: {
    formTitle () {
      return this.editedIndex === -1 ? 'New Item' : 'Edit Item'
    },

    selected () {
      if (!this.isMounted) {
        return
      }

      return this.$refs['my-table'].selectedRowCount > 0
    },

    totalCount () {
      if (!this.isMounted) {
        return
      }

      return this.$refs['my-table'].totalRowCount
    }
  },

  watch: {
    currentYear: {
      handler: function (val, oldVal) {
        this.getBooths()
      },
      deep: true
    }
  },

  methods: {
    handleResize () {
      const height = window.innerHeight - 360
      this.height = height + 'px'
    },

    async getEmails () {
      try {
        const response = await Api().get('get_email_vendors/')

        const emails = response.data
        console.log(emails)

        for (let i in emails) {
          let item = {}
          let dDate = moment(emails[i].createdAt).format('MM/DD/YYYY - hh:mm A')
          item.to = emails[i].to
          item.from = emails[i].from
          item.subject = emails[i].subject
          item.date = dDate
          item.createdAt = emails[i].createdAt
          this.rows.push(item)
        }
        // this.rows = response.data

        this.isTableLoading = false
      } catch (error) {
        this.error = error.response.data.error
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    newItem () {
      this.dialog = true
    },

    editItem (props) {
      this.evalItem = props.row

      // this.dialog = true
    },

    async save () {
      if (this.evalItem.id > 0) {
        this.edit()
      } else {
        this.add()
      }
    },

    async add () {
      const result = this.rows.find(({ boothNumber }) => boothNumber === Number(this.evalItem.boothNumber))

      if (result) {
        this.snackbar.message = 'The booth number ' + this.evalItem.boothNumber + ' is already assigned!'
        this.snackbar.color = 'error'
        this.snackbar.show = true
      } else {
        try {
          this.evalItem.year = this.currentYear
          this.evalItem.location = 'Vendor Alley'

          const response = await Api().post('vendor_booths', this.evalItem)

          this.getEmails()
          this.evalItem = {}
          this.dialog = false

          this.snackbar.message = response.data.message
          this.snackbar.color = 'success'
          this.snackbar.show = true
        } catch (error) {
          this.snackbar.message = error.response.data.error
          this.snackbar.color = 'error'
          this.snackbar.show = true
        }
      }
    },

    async edit () {
      try {
        const response = await Api().put('vendor_booths/' + this.evalItem.id, this.evalItem)

        this.evalItem = {}
        this.dialog = false

        this.snackbar.message = response.data.message
        this.snackbar.color = 'success'
        this.snackbar.show = true
      } catch (error) {
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    close () {
      this.evalItem = {}
      this.dialog = false
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.vgt-fixed-header {
  z-index: 1;
}

.vgt-fixed-header th:last-child {
    /* Offset for the scrollbar, you may have to adjust this */
    width: calc(100% + 17px) !important;
}

.croppa-container {
  background-color: white;
  border: 3px solid black
}
</style>



// WEBPACK FOOTER //
// src/components/vendor/Emails.vue